import { DataFlowModulePack } from './DataFlowModulePack';
import { DataFlowModuleOption } from './DataFlowModuleOption';
import { DataFlowModuleDisplay } from './DataFlowModuleDisplay';

export class DataFlowModulePackSetup {
  public Displays: DataFlowModuleDisplay[];

  public Options: DataFlowModuleOption[];

  public Pack: DataFlowModulePack;
}
